import React from 'react'
import { Typography, Box, withTheme, WithStyles, withStyles, Theme } from '@material-ui/core';
import { ThemedComponentProps } from '@material-ui/core/styles/withTheme';

type Props = ThemedComponentProps & WithStyles & {children: React.ReactNode} 
type State = {
    hasError: boolean
    error: any
}

const styles = (theme: Theme) => ({
    root: {
        padding: theme.spacing(2)
    }
});

class ErrorBoundary extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            hasError: false,
            error: false
        }
    }

    static getDerivedStateFromError() {
        console.log("ErrorBoundary getDerivedStateFromError called");
        return {
            hasError: true
        }
    }

    componentDidCatch(error: any, errorInfo: any) {
        this.setState({
            hasError: true
        });
        console.log("error Caught!!");
    }

    // const errorBoundary = <p>This is error boundary!</p>;
    render() {
        const { theme, classes } = this.props;
        const { hasError } = this.state;
        const {error} = this.state;

        if(error){
            return <Box className={classes.root} maxWidth={theme?.breakpoints.values.lg} margin="0 auto" textAlign="center">
                <Typography component={'span'} variant="h3">Oops! Something went wrong.</Typography>
                <Typography component={'span'}>My Error has been thrown</Typography>

            </Box>
        }
        if (hasError) {
            return <Box className={classes.root} maxWidth={theme?.breakpoints.values.lg} margin="0 auto" textAlign="center">
                <Typography component={'span'} variant="h3">Oops! Something went wrong.</Typography>
                <Typography component={'span'}>You may also want to refresh the page or try again later.</Typography>

            </Box>
        }
        return this.props.children;
    }
}

export default withStyles(styles)(withTheme(ErrorBoundary))
